import { stripLeadingAtSign } from 'uScope/js/lib/utility/helpers';

export function UrlBuilder (inUrlRoot, inImageId, quality = 80) {
  const self = this;
  let urlRoot = inUrlRoot;
  let imageId = inImageId;
  let imageQuality = `+${quality}`;

  self.setImageId = function (id) {
    imageId = stripLeadingAtSign(id);
    const ix = urlRoot.lastIndexOf('@') + 1;
    urlRoot = urlRoot.substr(0, ix) + imageId;
  };

  self.setQuality = quality => {
    if (quality > 50) {
      imageQuality = `+${quality}`;
    }
  };

  self.thumb = (width, height) => {
    // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+435+0+-1
    // - note that id is not used as it is appended already to the 'urlRoot'
    return urlRoot + '?' + '0+0+' + width + '+' + height + '+-4';
  };

  self.label = (width, height) => {
    // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+122+122+-2
    // - note that id is not used as it is appended already to the 'urlRoot'
    return urlRoot + '?' + '0+0+' + width + '+' + height + '+-2';
  };

  self.region = (x, y, width, height, zoom, isProgressive = false) => {
    // I would like to round each of these values as they come in, but the ImageServer has some odd rules about how
    // it interprets these values. For instance, prefixing X and Y coordinates tells it that the coordinate is
    // actually relative to the image's base coordinates. I'm not sure what other odd rules are embedded in that
    // server but given how often this method is called I feel its too risky to attempt to round coming requests.

    // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+1956+1628+27
    // - note that id is not used as it is appended already to the 'urlRoot'
    let url = urlRoot + '?' + x + '+' + y + '+' + width + '+' + height + '+' + zoom + imageQuality;
    if (isProgressive) {
      url += '+P';
    }
    return url;
  };
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/utility/UrlBuilder.js